module.exports = __webpack_public_path__ + "static/img/zengniyou.479bf25.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/zengniyou.png
// module id = GBbs
// module chunks = 1